import * as React from "react";

import SpinGeneralContainer from "./spins/spinGeneral.container";
import HorizontalBarContainer from "./layouts/horizontalBar.container";
import HotspotsOverlaysContainer from "./overlays/hotspotsOverlays.container";
import TopBarContainer from "./layouts/topBar.container";
import TownplanningContainer from "./moduls/townplanning.container";
import TownplanningOverlaysContainer from "./overlays/TownplanningOverlays.container";
import AmenitiesContainer from "./moduls/amenities.container";
import AmenitiesOverlaysContainer from "./overlays/AmenitiesOverlays.container";
import GaleriesContainer from "./galeries/galeries.container";
import GaleriesContenidoContainer from "./galeries/galeriesContenido.container";

import PropertiesContainer from "./moduls/properties.container";
import PropertiesOverlaysContainer from "./overlays/PropertiesOverlays.container";
import DetailsOverlaysContainer from "./overlays/DetailsOverlays.container";
import TooltipContainer from "./overlays/tooltip.container";
import LocationContainer from "./moduls/location.container";
import MapComponent from "./maps/map.container";
import LoadingSpinner from "./layouts/loading.container";
import AsoleacionContainer from "./moduls/asoleacion.container";
import SpinAsoleacionContainer from "./spins/spinAsoleacionVista3.container";
import ContactModalContainer from "./layouts/contactModal.container";
import SpinAsoleacionVista1Container from "./spins/spinAsoleacionVista1.container";
import SpinAsoleacionVista2Container from "./spins/spinAsoleacionVista2.container";
import SpinAsoleacionVista3Container from "./spins/spinAsoleacionVista3.container";
import LegalText from "./layouts/legalText.container";
import CotizacionContainer from "./moduls/cotizacion.container";

declare const window: any;

interface DragInfo {
  x: number;
}

export default function CanvaContainer({
  data,
  introView,
  isTheme,
  setIsTheme,
  imageDivs,
}: any) {
  const [spinAsoleacionDataV1, setSpinAsoleacionDataV1]: any = React.useState(
    {}
  );
  const [spinAsoleacionDataV2, setSpinAsoleacionDataV2]: any = React.useState(
    {}
  );
  const [spinAsoleacionDataV3, setSpinAsoleacionDataV3]: any = React.useState(
    {}
  );
  const [spinData, setSpinData]: any = React.useState({});
  const [frame, setFrame]: any = React.useState(1);
  const [frameTemp, setFrameTemp]: any = React.useState({});
  const [frameTempIndex, setFrameTempIndex]: any = React.useState(1);
  const [isSelectedTownplanning, setIsSelectedTownplanning] =
    React.useState("");
  const [isSelectedPOI, setIsSelectedPOI]: any = React.useState([]);
  const [isSelectedVIA, setIsSelectedVIA]: any = React.useState([]);
  const [isSelectedApto, setIsSelectedApto]: any = React.useState({});
  const [isSelectedAttribute, setIsSelectedAttribute]: any = React.useState({});
  const [currentSelectedAttribute, setCurrentSelectedAttribute]: any =
    React.useState({});
  const [isSelectedAmenities, setIsSelectedAmenities]: any = React.useState("");
  const [isSelectedAmenitiesAttributes, setIsSelectedAmenitiesAttribute] =
    React.useState([]);
  const [spinSelected, setSpinSelected]: any = React.useState([]);
  const [galeriaSelected, setGaleriaSelected] = React.useState([]);
  const [originalGleriaSelected, setOriginalGleriaSelected] = React.useState(
    []
  );
  const [hotspotsUrl, setHotspotsUrl] = React.useState("");
  const [townplanningUrl, setTownplanningUrl] = React.useState("");
  const [amenitiesUrl, setAmenitiesUrl] = React.useState("");
  const [inmueblesUrl, setInmueblesUrl] = React.useState("");
  const [inmueblesDetailsUrl, setInmueblesDetailsUrl] = React.useState("");
  const [originalWidth, setOriginalWidth] = React.useState(2000);
  const [originalHeight, setOriginalHeight] = React.useState(1400);
  const [menuSelected, setMenuSelected] = React.useState("");
  const [subMenuSelected, setSubMenuSelected] = React.useState("");
  const [subMenuSelectedTemp, setSubMenuSelectedTemp] = React.useState("");
  const [groupGalerySelected, setGroupGalerySelected] = React.useState("");
  const [isPortrait, setIsPortrait] = React.useState(false);
  const [selectAvailability, setSelectAvailability] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [isAsoleacion, setIsAsoleacion] = React.useState(false);
  const [isCotizacion, setIsCotizacion] = React.useState(false);
  const [selectedCotizacion, setSelectedCotizacion] = React.useState([]);
  const [isMomentDay, setIsMomentDay] = React.useState("MedioDia");
  const [isView, setIsVew]: any = React.useState({});
  const [selectedTime, setSelectedTime] = React.useState(1);
  const [isSideBarAsoleacion, setIsSideBarAsoleacion] = React.useState(false);
  const [isShowAsoleacion, setIShowAsoleacion] = React.useState(false);
  const [showSetting, setShowSetting] = React.useState("");
  const [showTextHotspots, setShowTextHotspots] = React.useState(true);
  const [isSideBarVertical, setIsSideBarVertical] = React.useState(true);
  const [isHiddenHorizontal, setIsHiddenHorizontal] = React.useState(true);
  const [isAnimationAmenities, setIsAnimationAmenites] = React.useState(false);
  const [isAnimationAttribute, setIsAnimationAttribute] = React.useState(false);
  const [dragStart, setDragStart] = React.useState<DragInfo | null>(null);
  const [isContactModal, setIsContactModal] = React.useState(false);
  const [isMapRender, setIsMapRender] = React.useState(false);
  const [isLegalText, setIsLegalText] = React.useState(true);
  //const [isLoading, setIsLoading] = useState(true);
  const [windowDimensions, setWindowDimensions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    if (!introView) {
      setIsAsoleacion(false);
      setTimeout(() => {
        if (data?.asoleacion?.length > 0) {
          setIsAsoleacion(true);
        }
      }, 500);
    }
  }, [introView]);

  React.useEffect(() => {
    if (Object.keys(isView).length > 0) {
      setSelectedTime(data?.keyFrameAsoleacion);
      if (isView?.name === "Vista 1") {
        const vista1: any = document.querySelector(".vista1");
        const vista2: any = document.querySelector(".vista2");
        const vista3: any = document.querySelector(".vista3");

        if (vista1) {
          vista1.style.display = "initial";
        }
        if (vista2) {
          vista2.style.display = "none";
        }
        if (vista3) {
          vista3.style.display = "none";
        }
      } else if (isView?.name === "Vista 2") {
        const vista1: any = document.querySelector(".vista1");
        const vista2: any = document.querySelector(".vista2");
        const vista3: any = document.querySelector(".vista3");

        if (vista1) {
          vista1.style.display = "none";
        }
        if (vista2) {
          vista2.style.display = "initial";
        }
        if (vista3) {
          vista3.style.display = "none";
        }
      } else if (isView?.name === "Vista 3") {
        const vista1: any = document.querySelector(".vista1");
        const vista2: any = document.querySelector(".vista2");
        const vista3: any = document.querySelector(".vista3");

        if (vista1) {
          vista1.style.display = "none";
        }
        if (vista2) {
          vista2.style.display = "none";
        }
        if (vista3) {
          vista3.style.display = "initial";
        }
      }
    }
  }, [isView]);

  React.useEffect(() => {
    setShowSetting("");
    setIsContactModal(false);
  }, [frame]);

  React.useEffect(() => {
    setIsContactModal(false);
    if (showSetting === "show") {
      setIsVew({});
      setIsSideBarAsoleacion(false);
      !window.functionIsPortrait() && window.functionIsMobileDevice()
        ? setIsAsoleacion(false)
        : null;
    } else {
      !window.functionIsPortrait() && window.functionIsMobileDevice()
        ? setIsAsoleacion(true)
        : null;
    }
  }, [showSetting]);

  React.useEffect(() => {
    setIsContactModal(false);
    if (isSideBarAsoleacion) {
      setShowSetting("");
      if (data?.asoleacion.length > 0) {
        setIsVew(data?.asoleacion[0]);
        console.log(isView?.frame);

        setFrame(data?.asoleacion[0]?.frame);
      }
    } else {
      setFrame(frame);
      setIShowAsoleacion(false);
    }
  }, [isSideBarAsoleacion]);

  React.useEffect(() => {
    if (window.innerWidth > window.innerHeight) {
      setIsPortrait(false);
      setSpinData(
        data.spin.filter((objeto) => objeto.type === "General landscape")[0]
      );
      setFrameTemp(
        data.spin.filter((objeto) => objeto.type === "General landscape")[0]
      );
      setSpinAsoleacionDataV1(
        data.spin.filter(
          (objeto) =>
            objeto.name === "Vista 1" && objeto.type === "Asoleacion landscape"
        )[0]
      );
      setSpinAsoleacionDataV2(
        data.spin.filter(
          (objeto) =>
            objeto.name === "Vista 2" && objeto.type === "Asoleacion landscape"
        )[0]
      );
      setSpinAsoleacionDataV3(
        data.spin.filter(
          (objeto) =>
            objeto.name === "Vista 3" && objeto.type === "Asoleacion landscape"
        )[0]
      );
      setHotspotsUrl(data.hotspots.json_landscape);
      setOriginalWidth(2000);
      setOriginalHeight(1400);
    } else {
      setIsPortrait(true);
      setSpinData(
        data.spin.filter((objeto) => objeto.type === "General portrait")[0]
      );
      setFrameTemp(
        data.spin.filter((objeto) => objeto.type === "General portrait")[0]
      );
      setSpinAsoleacionDataV1(
        data.spin.filter(
          (objeto) =>
            objeto.name === "Vista 1" && objeto.type === "Asoleacion portrait"
        )[0]
      );
      setSpinAsoleacionDataV2(
        data.spin.filter(
          (objeto) =>
            objeto.name === "Vista 2" && objeto.type === "Asoleacion portrait"
        )[0]
      );
      setSpinAsoleacionDataV3(
        data.spin.filter(
          (objeto) =>
            objeto.name === "Vista 3" && objeto.type === "Asoleacion portrait"
        )[0]
      );
      setHotspotsUrl(data.hotspots.json_portrait);
      setOriginalHeight(2000);
      setOriginalWidth(1400);
    }
    setSelectAvailability({
      DISPONIBLE: data?.state_disponible,
      VENDIDO: data?.state_vendido,
      "NO DISPONIBLE": data?.state_no_disponible,
      RESERVADO: data?.state_reservado,
    });
    if (data?.asoleacion?.length > 0) {
      setIsAsoleacion(true);
    }
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const prevMenuSelectedRef: any = React.useRef();

  React.useEffect(() => {
    // Accede al estado anterior de menuSelected
    const prevMenuSelected = prevMenuSelectedRef.current;

    // Tu código de useEffect
    setFrameTempIndex(frame);
    setFrameTemp(spinData);
    setIsContactModal(false);
    setShowSetting("");

    setIsSideBarAsoleacion(false), setIsVew({});
    if (menuSelected === "Urbanismo") {
      if (windowDimensions.width > windowDimensions.height) {
        if (
          !(
            spinData ===
            data.spin.filter(
              (objeto) => objeto.type === "Urbanismo landscape"
            )[0]
          )
        ) {
          setFrame(1);
        }

        setSpinData(
          data.spin.filter((objeto) => objeto.type === "Urbanismo landscape")[0]
        );
        setTownplanningUrl(data.townPlanning.json_landscape);
        setOriginalWidth(2000);
        setOriginalHeight(1400);
      } else {
        if (
          !(
            spinData ===
            data.spin.filter(
              (objeto) => objeto.type === "Urbanismo portrait"
            )[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "Urbanismo portrait")[0]
        );
        setTownplanningUrl(data.townPlanning.json_portrait);
        setOriginalHeight(2000);
        setOriginalWidth(1400);
      }
    } else if (menuSelected === "") {
      if (windowDimensions.width > windowDimensions.height) {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General landscape")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General landscape")[0]
        );
        setHotspotsUrl(data.hotspots.json_landscape);
        setOriginalWidth(2000);
        setOriginalHeight(1400);
      } else {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General portrait")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General portrait")[0]
        );
        setHotspotsUrl(data.hotspots.json_portrait);
        setOriginalHeight(2000);
        setOriginalWidth(1400);
      }
    } else if (menuSelected === "Amenidades") {
      if (windowDimensions.width > windowDimensions.height) {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General landscape")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General landscape")[0]
        );
        setAmenitiesUrl(data.amenities.script.json_landscape);
        setOriginalWidth(2000);
        setOriginalHeight(1400);
      } else {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General portrait")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General portrait")[0]
        );
        setAmenitiesUrl(data.amenities.script.json_portrait);
        setOriginalHeight(2000);
        setOriginalWidth(1400);
      }
    } else if (menuSelected === "Inmuebles") {
      if (windowDimensions.width > windowDimensions.height) {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General landscape")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General landscape")[0]
        );
        setInmueblesUrl(data.properties.script.json_landscape);
        setHotspotsUrl(data.hotspots.json_landscape);
        setOriginalWidth(2000);
        setOriginalHeight(1400);
      } else {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General portrait")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General portrait")[0]
        );
        setInmueblesUrl(data.properties.script.json_portrait);
        setHotspotsUrl(data.hotspots.json_portrait);
        setOriginalHeight(2000);
        setOriginalWidth(1400);
      }
    } else if (menuSelected === "Galería") {
      setGaleriaSelected(data?.galleries);
      setSubMenuSelected("Galería");
    }

    // Guarda el valor actual de menuSelected en el ref para la próxima renderización
    prevMenuSelectedRef.current = menuSelected;
  }, [menuSelected, windowDimensions]);

  React.useEffect(() => {
    setFrameTemp(spinData);
    setIsContactModal(false);
    if (
      menuSelected === "Inmuebles" &&
      subMenuSelected !== "" &&
      subMenuSelected !== "Galería"
    ) {
      let currentDetails: any = data?.details.find(
        (e) => e.group === subMenuSelected
      );
      if (currentDetails?.spin) {
        if (windowDimensions.width > windowDimensions.height) {
          if (
            !(
              spinData ===
              data.spin.find((objeto) => objeto.id === currentDetails.spin)
            )
          ) {
            setFrame(1);
          }
          setSpinData(
            data.spin.find((objeto) => objeto.id === currentDetails.spin)
          );
          setInmueblesDetailsUrl(currentDetails.json_landscape);
          setOriginalWidth(2000);
          setOriginalHeight(1400);
        } else {
          if (
            !(
              spinData ===
              data.spin.find(
                (objeto) => objeto.id === currentDetails.spinPortrait
              )
            )
          ) {
            setFrame(1);
          }
          setSpinData(
            data.spin.find(
              (objeto) => objeto.id === currentDetails.spinPortrait
            )
          );
          setInmueblesDetailsUrl(currentDetails.json_portrait);
          setOriginalHeight(2000);
          setOriginalWidth(1400);
        }
      }
      

      let currentProperty: any = data?.properties?.property?.find(
        (e) => e.id === subMenuSelected
      );
      if (currentProperty?.spins?.length > 0) {
        if (windowDimensions.width > windowDimensions.height) {
          if (
            !(
              spinData ===
              data?.spin?.find((objeto) => objeto.id === currentProperty?.spins[0]?.spin_landscape)
            )
          ) {
            setFrame(1);
          }
          setSpinData(
            data.spin.find((objeto) => objeto.id === currentProperty?.spins[0]?.spin_landscape)
          );
          setInmueblesDetailsUrl("");
          setOriginalWidth(2000);
          setOriginalHeight(1400);
          setIsSelectedApto({})
        } else {
          if (
            !(
              spinData ===
              data.spin.find(
                (objeto) => objeto.id === currentProperty?.spins[0]?.spin_portrait
              )
            )
          ) {
            setFrame(1);
          }
          setSpinData(
            data.spin.find(
              (objeto) => objeto.id === currentProperty?.spins[0]?.spin_portrait
            )
          );
          setInmueblesDetailsUrl("");
          setOriginalHeight(2000);
          setOriginalWidth(1400);
          setIsSelectedApto({})
        }
      }
    }

    if (subMenuSelected === "Spin") {
      let currentDetails: any = data?.details.find(
        (e) => e.group === subMenuSelected
      );
      if (windowDimensions.width > windowDimensions.height) {
        if (!(spinData === spinSelected?.spinLandscape)) {
          setFrame(1);
        }
        setSpinData(spinSelected?.spinLandscape);
        setOriginalWidth(2000);
        setOriginalHeight(1400);
      } else {
        if (!(spinData === spinSelected?.spinPortrait)) {
          setFrame(1);
        }
        setSpinData(spinSelected?.spinPortrait);
        setOriginalHeight(2000);
        setOriginalWidth(1400);
      }
    } else if (menuSelected === "Amenidades" && subMenuSelected === "") {
      if (windowDimensions.width > windowDimensions.height) {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General landscape")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General landscape")[0]
        );
        setAmenitiesUrl(data.amenities.script.json_landscape);
        setOriginalWidth(2000);
        setOriginalHeight(1400);
      } else {
        if (
          !(
            spinData ===
            data.spin.filter((objeto) => objeto.type === "General portrait")[0]
          )
        ) {
          setFrame(1);
        }
        setSpinData(
          data.spin.filter((objeto) => objeto.type === "General portrait")[0]
        );
        setAmenitiesUrl(data.amenities.script.json_portrait);
        setOriginalHeight(2000);
        setOriginalWidth(1400);
      }
    }
  }, [subMenuSelected, windowDimensions]);

  React.useEffect(() => {
    setIsContactModal(false);
    console.log(isSelectedAmenities);
    console.log(data?.amenities?.menu);

    /* console.log(data?.amenities?.menu.map((amenidad) => amenidad.amenities.find((a) => a.id === isSelectedAmenities)?.mainFrame)
      .find((mainFrame) => mainFrame !== undefined)); */

    if (isSelectedAmenities !== "") {
      setFrame(
        data?.amenities_hierarchical === 0
          ? data?.amenities?.menu?.find((a) => a.id === isSelectedAmenities)
              ?.mainFrame ?? 1
          : data?.amenities?.menu
              .map(
                (amenidad) =>
                  amenidad.amenities.find((a) => a.id === isSelectedAmenities)
                    ?.mainFrame ?? 1
              )
              .find((mainFrame) => mainFrame !== undefined) ?? 1
      );
    }
  }, [isSelectedAmenities]);

  React.useEffect(() => {
    setIsContactModal(false);
    if (Object.keys(currentSelectedAttribute).length > 0) {
      const generalFrame = data?.properties?.attributesFrame?.find(
        (e: any) =>
          e.value === currentSelectedAttribute?.id && e.type === "GENERAL"
      )?.frame;

      const detailFrame = data?.properties?.attributesFrame?.find(
        (e: any) =>
          e.value === currentSelectedAttribute?.id &&
          e.type === "DETAIL" &&
          e.hierarchical ===
            data?.properties?.attributes
              .find((o: any) => o.id === e.attribute_hierarchical)
              .values.find(
                (u: any) => u.value.replace(/\s+/g, "") === subMenuSelected
              )?.id
      )?.frame;

      console.log(detailFrame);

      if (generalFrame !== undefined || detailFrame !== undefined) {
        setFrame(subMenuSelected === "" ? generalFrame : detailFrame);
      }
    }
  }, [currentSelectedAttribute]);

  return (
    <div
      className={`canva-container ${!introView ? "active" : ""}`}
      //onClick={() => setShowSetting("")}
      style={
        Object.keys(spinData).length > 0
          ? {
              backgroundImage: `url(${
                window.hybrid
                  ? ""
                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
              }${(spinData?.files[frame - 1]).replace(/ /g, "%20")})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              //display: isLegaltext ? "block" : "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundPosition: "center 50%",
            }
          : {}
      }
    >
      <div
        className={`canva-container ${
          !introView //&& !isLoading
            ? "active"
            : ""
        }`}
        style={
          menuSelected !== "Ubicación" && Object.keys(spinData).length > 0
            ? {
                backgroundImage: `url(${
                  window.hybrid
                    ? ""
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                }${(spinData?.files[
                  /* (menuSelected === "Urbanismo" ||
                    (menuSelected === "Inmuebles" &&
                      subMenuSelected !== "" &&
                      subMenuSelected !== "Galería")) &&
                  frame > 50
                    ? Math.round(frame / 2 - 1)
                    : menuSelected === "Amenidades" &&
                      subMenuSelected !== "" &&
                      subMenuSelected !== "Galería" &&
                      frame > 25 &&
                      frame <= 50 &&
                      spinData?.files?.length === 25
                    ? Math.round(frame / 2 - 1)
                    : menuSelected === "Amenidades" &&
                      subMenuSelected !== "" &&
                      subMenuSelected !== "Galería" &&
                      frame > 50 &&
                      spinData?.files?.length === 25
                    ? Math.round(frame / 4 - 1)
                    : menuSelected === "Amenidades" &&
                      subMenuSelected !== "" &&
                      subMenuSelected !== "Galería" &&
                      frame > 50 &&
                      spinData?.files?.length > 25
                    ? Math.round(frame / 2 - 1)
                    : */ frame - 1
                ]).replace(/ /g, "%20")})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                //display: isLegaltext ? "block" : "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundPosition: "center 50%",
              }
            : { backgroundColor: "#FFF" }
        }
      >
        {menuSelected !== "Ubicación" ? (
          <SpinGeneralContainer
            imageUrls={spinData.files}
            isSelectedAmenities={isSelectedAmenities}
            frame={frame}
            setFrame={setFrame}
            subMenuSelected={subMenuSelected}
            menuSelected={menuSelected}
            isView={isView}
            setIShowAsoleacion={setIShowAsoleacion}
            isShowAsoleacion={isShowAsoleacion}
            dragStart={dragStart}
            setDragStart={setDragStart}
            imageDivs={imageDivs}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            isSelectedAttribute={isSelectedAttribute}
            currentSelectedAttribute={currentSelectedAttribute}
            attributesFrame={data?.properties?.attributesFrame}
            attributesValues={data?.properties?.attributes}
          />
        ) : (
          <MapComponent
            isSelectedPOI={isSelectedPOI}
            isSelectedVIA={isSelectedVIA}
            isMapRender={isMapRender}
            data={data?.location}
          />
        )}
        {!isLoading ? (
          <SpinAsoleacionVista1Container
            imageUrls={
              spinAsoleacionDataV1?.files !== undefined
                ? spinAsoleacionDataV1?.files
                : []
            }
            frame={selectedTime}
            setFrame={setSelectedTime}
            isMomentDay={isMomentDay}
            vista="vista1"
            isShowAsoleacion={isShowAsoleacion && isView?.name === "Vista 1"}
          />
        ) : null}
        {!isLoading ? (
          <SpinAsoleacionVista2Container
            imageUrls={
              spinAsoleacionDataV2?.files !== undefined
                ? spinAsoleacionDataV2?.files
                : []
            }
            frame={selectedTime}
            setFrame={setSelectedTime}
            isMomentDay={isMomentDay}
            vista="vista2"
            isShowAsoleacion={isShowAsoleacion && isView?.name === "Vista 2"}
          />
        ) : null}
        {!isLoading ? (
          <SpinAsoleacionVista3Container
            imageUrls={
              spinAsoleacionDataV3?.files !== undefined
                ? spinAsoleacionDataV3?.files
                : []
            }
            frame={selectedTime}
            setFrame={setSelectedTime}
            isMomentDay={isMomentDay}
            vista="vista3"
            isShowAsoleacion={isShowAsoleacion && isView?.name === "Vista 3"}
          />
        ) : null}
        {data?.texto_legal_secundario !== "" && isLegalText && !introView ? (
          <LegalText
            text={data?.texto_legal_secundario}
            isLegalText={isLegalText}
            setIsLegalText={setIsLegalText}
          />
        ) : null}
        {(subMenuSelected === "" || subMenuSelected === "Spin") &&
        ((window.functionIsPortrait() && menuSelected === "") ||
          !window.functionIsPortrait()) &&
        !isSideBarAsoleacion && !isCotizacion ? (
          <HorizontalBarContainer
            setSubMenuSelected={setSubMenuSelected}
            setSubMenuSelectedTemp={setSubMenuSelectedTemp}
            colors={data.colors}
            menus={data.menu_btns}
            builderLogo={data.logo_constructora}
            projectLogo={data.logo_proyecto}
            projectLogosMultiples={data.logos_multiples}
            active_builder_logo={data?.active_builder_logo}
            theme={isTheme}
            active={!introView ? "active" : ""}
            setMenuSelected={setMenuSelected}
            menuSelected={menuSelected}
            setFrame={setFrame}
            setGaleriaSelected={setGaleriaSelected}
            introView={introView}
            isHidden={isHiddenHorizontal}
            setIsHidden={setIsHiddenHorizontal}
            setIsSideBarVertical={setIsSideBarVertical}
            isLoading={isLoading}
            logo_invertido={data?.logo_invertido}
          />
        ) : null}
        {menuSelected === "Urbanismo" &&
        subMenuSelected === "" &&
        isSelectedTownplanning !== "" &&
        !isLoading ? (
          <TownplanningOverlaysContainer
            colors={data.colors}
            theme={isTheme}
            active={!introView ? "active" : ""}
            frame={frame}
            attribute={isSelectedTownplanning}
            townplanningUrl={townplanningUrl}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            attributes={data?.properties?.attributes}
          />
        ) : null}{" "}
        {menuSelected === "Inmuebles" &&
        subMenuSelected === "" &&
        !isLoading ? (
          <PropertiesOverlaysContainer
            setIsSelectedApto={setIsSelectedApto}
            isSelectedApto={isSelectedApto}
            colors={data.colors}
            theme={isTheme}
            active={!introView ? "active" : ""}
            frame={frame}
            filters={setIsSelectedAttribute}
            inmueblesUrl={inmueblesUrl}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            data={data?.properties}
            selectAvailability={selectAvailability}
            isSelectedAttribute={isSelectedAttribute}
            setIsAnimationAttribute={setIsAnimationAttribute}
            isAnimationAttribute={isAnimationAttribute}
            dragStart={dragStart}
            setDragStart={setDragStart}
          />
        ) : null}
        {menuSelected === "Inmuebles" &&
        subMenuSelected !== "" &&
        !isLoading ? (
          <DetailsOverlaysContainer
            setIsSelectedApto={setIsSelectedApto}
            isSelectedApto={isSelectedApto}
            colors={data.colors}
            theme={isTheme}
            active={!introView ? "active" : ""}
            frame={frame}
            filters={setIsSelectedAttribute}
            inmueblesUrl={inmueblesDetailsUrl}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            data={data?.properties}
            subMenuSelected={subMenuSelected}
            selectAvailability={selectAvailability}
            isSelectedAttribute={isSelectedAttribute}
            setIsAnimationAttribute={setIsAnimationAttribute}
            isAnimationAttribute={isAnimationAttribute}
            dragStart={dragStart}
            setDragStart={setDragStart}
          />
        ) : null}{" "}
        {menuSelected === "Amenidades" &&
        subMenuSelected === "" &&
        !isLoading ? (
          <AmenitiesOverlaysContainer
            colors={data.colors}
            theme={isTheme}
            active={!introView ? "active" : ""}
            frame={frame}
            amenidad={isSelectedAmenities}
            amenidadesAttributes={isSelectedAmenitiesAttributes}
            amenitiesUrl={amenitiesUrl}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            amenidades={data?.amenities?.menu}
            setSpinSelected={setSpinSelected}
            setGaleriaSelected={setGaleriaSelected}
            setOriginalGleriaSelected={setOriginalGleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            setIsAnimationAmenites={setIsAnimationAmenites}
            isAnimationAmenities={isAnimationAmenities}
            amenities_hierarchical={data?.amenities_hierarchical}
          />
        ) : null}{" "}
        {(subMenuSelected !== "" &&
          subMenuSelected !== "Spin" &&
          menuSelected !== "Inmuebles") ||
        (menuSelected === "Inmuebles" && subMenuSelected === "Galería") ? (
          <GaleriesContenidoContainer
            data={galeriaSelected}
            menuSelected={menuSelected}
            subMenuSelected={subMenuSelected}
            isSelected={groupGalerySelected}
            colors={data.colors}
            theme={isTheme}
            isSideBar={isSideBarVertical}
            isPortrait={window.functionIsPortrait()}
          />
        ) : null}{" "}
        {(menuSelected === "" || menuSelected === "Inmuebles") &&
        subMenuSelected === "" &&
        !isSideBarAsoleacion &&
        !isLoading ? (
          <HotspotsOverlaysContainer
            colors={data.colors}
            theme={isTheme}
            active={!introView ? "active" : ""}
            frame={frame}
            hotspotsUrl={hotspotsUrl}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            setMenuSelected={setMenuSelected}
            setSubMenuSelected={setSubMenuSelected}
            setSubMenuSelectedTemp={setSubMenuSelectedTemp}
            menuSelected={menuSelected}
            setFrame={setFrame}
            details={data?.details}
            showTextHotspots={showTextHotspots}
          />
        ) : null}
        {(subMenuSelected !== "Galería" || menuSelected !== "Galería") &&
        galeriaSelected?.length === 0 ? (
          <TopBarContainer
            isSelectedApto={isSelectedApto}
            subMenuSelected={subMenuSelected}
            menuSelected={menuSelected}
            setMenuSelected={setMenuSelected}
            setSubMenuSelected={setSubMenuSelected}
            colors={data.colors}
            theme={isTheme}
            active={!introView ? "active" : ""}
            setIsTheme={setIsTheme}
            setFrame={setFrame}
            setShow={setShowSetting}
            show={showSetting}
            setShowTextHotspots={setShowTextHotspots}
            showTextHotspots={showTextHotspots}
            isPortrait={window.functionIsPortrait()}
            setIsContactModal={setIsContactModal}
            isContactBtn={data?.isContact}
            isLoading={isLoading}
            setIsCotizacion={setIsCotizacion}
            cotizacion={data?.cotizaciion}
            isCotizacion={isCotizacion}
            properties={data?.properties?.property}
          />
        ) : null}
        {menuSelected === "Inmuebles" &&
        Object.keys(isSelectedApto).length > 0 &&
        subMenuSelected !== "Galería" ? (
          <TooltipContainer
            colors={data.colors}
            frame={frame}
            isSelectedApto={isSelectedApto}
            setIsSelectedApto={setIsSelectedApto}
            theme={isTheme}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            attributes={data?.properties?.attributes}
            cotizacion={data?.cotizaciion}
            setGaleriaSelected={setGaleriaSelected}
            setOriginalGleriaSelected={setOriginalGleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            setSelectedCotizacion={setSelectedCotizacion}
            selectedCotizacion={selectedCotizacion}
            setIsCotizacion={setIsCotizacion}
          />
        ) : null}
        {/* <TooltipContainer
            frame={frame}
            isSelectedApto={isSelectedApto}
            setIsSelectedApto={setIsSelectedApto}
            theme={isTheme}
            originalWidth={originalWidth}
            originalHeight={originalHeight}
            attributes={data?.properties?.attributes}
            cotizacion={data?.cotizaciion}
            setGaleriaSelected={setGaleriaSelected}
            setOriginalGleriaSelected={setOriginalGleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            active={menuSelected === "Inmuebles" &&
            subMenuSelected !== "Galería" ? true : false}
          /> */}
        {menuSelected === "Urbanismo" &&
        subMenuSelected === "" &&
        !isLoading ? (
          <TownplanningContainer
            data={data?.properties?.attributes}
            isPortrait={window.functionIsPortrait()}
            setGaleriaSelected={setGaleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            subMenuSelectedTemp={subMenuSelectedTemp}
            setMenuSelected={setMenuSelected}
            subMenuSelected={subMenuSelected}
            menuSelected={menuSelected}
            theme={isTheme}
            isSelected={isSelectedTownplanning}
            setIsSelected={setIsSelectedTownplanning}
            icono={
              data?.menu_btns.filter((e) => e.name === "Urbanismo")[0]?.icono
            }
            colors={data.colors}
            setFrame={setFrame}
            setIsSideBar={setIsSideBarVertical}
            isSideBar={isSideBarVertical}
          />
        ) : null}{" "}
        {menuSelected === "Amenidades" &&
        (subMenuSelected === "" || subMenuSelected === "Spin") &&
        !isLoading ? (
          <AmenitiesContainer
            data={data?.amenities?.menu}
            isPortrait={window.functionIsPortrait()}
            setSpinSelected={setSpinSelected}
            setGaleriaSelected={setGaleriaSelected}
            setOriginalGleriaSelected={setOriginalGleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            subMenuSelectedTemp={subMenuSelectedTemp}
            subMenuSelected={subMenuSelected}
            setMenuSelected={setMenuSelected}
            menuSelected={menuSelected}
            theme={isTheme}
            isSelected={isSelectedAmenities}
            isSelectedAttributes={isSelectedAmenitiesAttributes}
            setIsSelected={setIsSelectedAmenities}
            setIsSelectedAttributes={setIsSelectedAmenitiesAttribute}
            setCurrentSelectedAttribute={setCurrentSelectedAttribute}
            icono={
              data?.menu_btns.filter((e) => e.name === "Amenidades")[0]?.icono
            }
            colors={data.colors}
            setFrame={setFrame}
            setIsSideBar={setIsSideBarVertical}
            isSideBar={isSideBarVertical}
            setIsAnimationAmenites={setIsAnimationAmenites}
            amenities_hierarchical={data?.amenities_hierarchical}
          />
        ) : null}{" "}
        {menuSelected === "Inmuebles" &&
        subMenuSelected !== "Galería" &&
        !isLoading ? (
          <PropertiesContainer
            data={data}
            isPortrait={window.functionIsPortrait()}
            setGaleriaSelected={setGaleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            subMenuSelectedTemp={subMenuSelectedTemp}
            subMenuSelected={subMenuSelected}
            setMenuSelected={setMenuSelected}
            menuSelected={menuSelected}
            theme={isTheme}
            isSelected={isSelectedAmenities}
            setIsSelected={setIsSelectedAmenities}
            icono={
              data?.menu_btns.filter((e) => e.name === "Inmuebles")[0]?.icono
            }
            colors={data.colors}
            setIsSelectedAttribute={setIsSelectedAttribute}
            setCurrentSelectedAttribute={setCurrentSelectedAttribute}
            isSelectedAttribute={isSelectedAttribute}
            setSelectAvailability={setSelectAvailability}
            selectAvailability={selectAvailability}
            setFrame={setFrame}
            setIsSideBar={setIsSideBarVertical}
            isSideBar={isSideBarVertical}
            setIsAnimationAttribute={setIsAnimationAttribute}
          />
        ) : null}{" "}
        {(subMenuSelected !== "" &&
          subMenuSelected !== "Spin" &&
          menuSelected !== "Inmuebles") ||
        (menuSelected === "Inmuebles" &&
          subMenuSelected === "Galería" &&
          !isLoading) ? (
          <GaleriesContainer
            data={galeriaSelected}
            isPortrait={window.functionIsPortrait()}
            original={
              menuSelected === "Galería"
                ? data?.galleries
                : originalGleriaSelected
            }
            setGaleriaSelected={setGaleriaSelected}
            setSpinSelected={setSpinSelected}
            menuSelected={menuSelected}
            subMenuSelected={subMenuSelected}
            setMenuSelected={setMenuSelected}
            setSubMenuSelected={setSubMenuSelected}
            subMenuSelectedTemp={subMenuSelectedTemp}
            theme={isTheme}
            isSelected={groupGalerySelected}
            setIsSelected={setGroupGalerySelected}
            icono={
              data?.menu_btns.filter((e) => e.name === "Galería")[0]?.icono
            }
            colors={data.colors}
            setFrame={setFrame}
            setIsSideBar={setIsSideBarVertical}
            isSideBar={isSideBarVertical}
          />
        ) : null}
        {menuSelected === "Ubicación" && !isLoading ? (
          <LocationContainer
            data={data?.location}
            setIsMapRender={setIsMapRender}
            isMapRender={isMapRender}
            isPortrait={window.functionIsPortrait()}
            setIsSelectedPOI={setIsSelectedPOI}
            setIsSelectedVIA={setIsSelectedVIA}
            isSelectedPOI={isSelectedPOI}
            isSelectedVIA={isSelectedVIA}
            setGaleriaSelected={setGaleriaSelected}
            setSubMenuSelected={setSubMenuSelected}
            subMenuSelected={subMenuSelected}
            subMenuSelectedTemp={subMenuSelectedTemp}
            setMenuSelected={setMenuSelected}
            menuSelected={menuSelected}
            theme={isTheme}
            isSelected={isSelectedAmenities}
            setIsSelected={setIsSelectedAmenities}
            icono={
              data?.menu_btns.filter((e) => e.name === "Ubicación")[0]?.icono
            }
            colors={data.colors}
            setIsSelectedAttribute={setIsSelectedAttribute}
            setCurrentSelectedAttribute={setCurrentSelectedAttribute}
            isSelectedAttribute={isSelectedAttribute}
            setSelectAvailability={setSelectAvailability}
            selectAvailability={selectAvailability}
            setFrame={setFrame}
            setIsSideBar={setIsSideBarVertical}
            isSideBar={isSideBarVertical}
          />
        ) : null}{" "}
        {isAsoleacion && !introView && menuSelected === "" && !isLoading ? (
          <AsoleacionContainer
            vistas={data?.asoleacion}
            theme={isTheme}
            colors={data?.colors}
            setIsMomentDay={setIsMomentDay}
            isMomentDay={isMomentDay}
            setIsVew={setIsVew}
            isView={isView}
            setSelectedTime={setSelectedTime}
            selectedTime={selectedTime}
            setIsSideBar={setIsSideBarAsoleacion}
            isSideBar={isSideBarAsoleacion}
            setIShowAsoleacion={setIShowAsoleacion}
            setFrame={setFrame}
            keyTime={data?.keyFrameAsoleacion}
            isPortrait={window.functionIsPortrait()}
          />
        ) : null}{" "}
        {isCotizacion &&
        !introView &&
        (menuSelected === "" || menuSelected === "Inmuebles") &&
        !isLoading ? (
          <CotizacionContainer
            theme={isTheme}
            colors={data?.colors}
            setIsSideBar={setIsCotizacion}
            isSideBar={isCotizacion}
            isPortrait={window.functionIsPortrait()}
            selectedCotizacion={selectedCotizacion}
            setSelectedCotizacion={setSelectedCotizacion}
          />
        ) : null}{" "}
        <ContactModalContainer
          theme={isTheme}
          colors={data?.colors}
          isContactModal={isContactModal}
          setIsContactModal={setIsContactModal}
          builderLogo={data.logo_constructora}
          projectLogo={data.logo_proyecto}
          data={data?.contact}
          legalText={data?.texto_legal}
          projectLogosMultiples={data.logos_multiples}
          active_builder_logo={data?.active_builder_logo}
          logo_invertido={data?.logo_invertido}
        />
      </div>
    </div>
  );
}
